import { Middleware } from '@reduxjs/toolkit';
import { setApiState } from '../slices/apiStateSlice';
import { parseMFA } from '../utils/mfaHandling';

const mfaMiddleware: Middleware = (store) => (next: any) => (action: any) => {
  const isFulfilled = action?.meta?.requestStatus === 'fulfilled';

  if (isFulfilled) {
    if (action?.payload?.code === 'MFARequired') {
      const newAction = {
        ...action,
        payload: {
          ...action?.payload,
          code: 'MFARequired',
        },
      };

      // Parse the MFA response
      const mfaHandler = parseMFA(newAction);

      if (mfaHandler) {
        store.dispatch(
          setApiState({
            status: mfaHandler.status,
            code: mfaHandler.code,
            action: mfaHandler.action,
            actionType: mfaHandler.actionType,
            message: mfaHandler.message,
            detail: mfaHandler.detail,
            showDetails: mfaHandler.showDetails,
          }),
        );
      }
    }
  }

  return next(action);
};

export default mfaMiddleware;
